import EmblaCarousel from 'embla-carousel';

(function (once, Drupal) {
  Drupal.behaviors.emblaBehavior = {
    attach: function (context, settings) {
      once('emblaBehavior', 'div.embla', context).forEach(function (rootNode) {
        // Grab wrapper nodes
        const viewportNode = rootNode.querySelector('.embla__viewport');

        // Grab button nodes
        const prevButtonNode = rootNode.querySelector('.embla__prev');
        const nextButtonNode = rootNode.querySelector('.embla__next');
        const buttonsContainer = rootNode.querySelector('.embla__buttons');

        // Initialize the carousel
        const embla = EmblaCarousel(viewportNode, {
          containScroll: 'trimSnaps',
          align: 'start',
          slidesToScroll: 1,
        });

        // Add click listeners
        prevButtonNode.addEventListener('click', embla.scrollPrev, false);
        nextButtonNode.addEventListener('click', embla.scrollNext, false);

        const setNavTopOffset = () => {
          // find the tallest image in swiperElement and set css var to its height on the parent embla container
          const images = viewportNode.querySelectorAll('img');
          let maxHeight = 0;
          images.forEach((img) => {
            if (img.clientHeight > maxHeight) {
              maxHeight = img.clientHeight;
            }
          });

          rootNode.style.setProperty(
            '--embla-navigation-top-offset',
            `${maxHeight / 2}px`
          );
        };

        embla.on('init', function () {
          setNavTopOffset();
          updateButtons();
        });

        embla.on('resize', function () {
          setNavTopOffset();
          updateButtons();
        });

        function updateButtons() {
          if (embla.canScrollPrev() || embla.canScrollNext()) {
            buttonsContainer.classList.remove('hidden');
          } else {
            buttonsContainer.classList.add('hidden');
          }
        }
      });
    },
  };
})(once, Drupal);
